export interface IState {
  searchResult: ISearchResult;
  query: string;
  searchedQuery: string;
  hitsPerPage: number;
  currentPage: number;
  title: string;
  subtitle: string;
  message: string;
  endpoints: {
    searchURL: string;
  };
  focus: IFocus;
  suggestion?: string;
  translations: ITranslations;
  preamble: string;
}
export interface ITranslations {
  searchUKA: string;
  allTypes: string;
  showMore: string;
  showing: string;
  outOf: string;
  pageTypePicked: string;
  pageTypesPicked: string;
  noHitsHeading: string;
  tryThis: string;
  checkSpelling: string;
  trySynonym: string;
  lessSpecificKeywords: string;
  searchResultFor: string;
  searchResult: string;
  weFound: string;
  hit: string;
  hits: string;
  matchingYourQuery: string;
  didYouMean: string;
  placeholder: string;
  searchForEvent: string;
  conference: string;
  seminar: string;
  searchButton: string;
  clearButton: string;
  title: string;
  thereAreCurrently: string;
  pieces: string;
  operationalDisturbance: string;
  operationalDisturbances: string;
}
export interface IFocus {
  shouldFocus: boolean;
  index: number;
}
export interface ISearchResult {
  searchHits: ISearchHit[];
  totalHits: number;
  suggestion?: string;
}
export interface ISearchHit {
  uri: string;
  title: string;
  preamble: string;
  area: string;
  place: string;
  plannedStartString: string;
  expectedFinishString: string;
  lastPublishedString: string;
  lastUpdatedString: string;
}

const deafultState: IState = {
  searchResult: {
    searchHits: [],
    totalHits: 0,
  },
  query: "",
  searchedQuery: "",
  hitsPerPage: 10,
  currentPage: 0,
  title: "",
  subtitle: "",
  message: "",
  endpoints: {
    searchURL: "",
  },
  focus: {
    shouldFocus: false,
    index: 0,
  },
  suggestion: undefined,
  translations: {
    searchUKA: "",
    allTypes: "",
    showMore: "",
    showing: "",
    outOf: "",
    pageTypePicked: "",
    pageTypesPicked: "",
    noHitsHeading: "",
    tryThis: "",
    checkSpelling: "",
    trySynonym: "",
    lessSpecificKeywords: "",
    searchResultFor: "",
    searchResult: "",
    weFound: "",
    hit: "",
    hits: "",
    matchingYourQuery: "",
    didYouMean: "",
    placeholder: "",
    searchForEvent: "",
    conference: "",
    seminar: "",
    searchButton: "",
    clearButton: "",
    title: "",
    thereAreCurrently: "",
    pieces: "",
    operationalDisturbance: "",
    operationalDisturbances: "",
  },
  preamble: "",
};

export default deafultState;
